import { CONSTANTS } from '$lib/defaults/constants.all';
import { handleErrorWithSentry } from '@sentry/sveltekit';
import * as Sentry from '@sentry/sveltekit';
import type { HandleClientError } from '@sveltejs/kit';

const sampleRate = CONSTANTS.IS_DEV ? 0 : 1.0;
const moduleFailedMessage = 'Importing a module';
const moduleFailedMessage2 = `loading dynamically imported`;
const UnexpectedToken = `Unexpected token '<'`;
const TranslationError = `The object does not support the operation or argument.`;
const OwnerDocument = 'ownerDocument';
const messages = [moduleFailedMessage, moduleFailedMessage2, UnexpectedToken, TranslationError, OwnerDocument];

if (!CONSTANTS.IS_DEV) {
	Sentry.init({
		dsn: CONSTANTS.SENTRY_DSN,
		tracesSampleRate: sampleRate,
		replaysSessionSampleRate: sampleRate,
		replaysOnErrorSampleRate: sampleRate,
		enabled: !CONSTANTS.IS_DEV && CONSTANTS.IS_HIGHER_ENV,
		environment: CONSTANTS.ENV,
		ignoreErrors: [
			'TypeError: Failed to fetch',
			'TypeError: Failed to fetch dynamically imported module',
			'TypeError: NetworkError when attempting to fetch resource.',
			'TypeError: Cancelled',
			'TypeError: cancelled',
			`reading 'ownerDocument'`,

			...messages
		],
		allowUrls: ['splitit.com']
	});
}

const handleClientError = (({ error, event }) => {
	const err = error as Error;

	try {
		const message = (err.message || '') as string;
		const messages = [moduleFailedMessage, moduleFailedMessage2, UnexpectedToken, TranslationError];
		if (messages.some((m) => message.toLocaleLowerCase().includes(m.toLocaleLowerCase()))) window.location.reload();
	} catch (error) {}
}) satisfies HandleClientError;

// If you have a custom error handler, pass it to `handleErrorWithSentry`
export const handleError = handleErrorWithSentry(handleClientError);
